export default __webpack_public_path__ + "assets/images/8d405e7ecd5c3942a6d02b75e71bcb5a.png";